export interface FullNameParams {
    firstName?: string;
    lastName?: string;
    oldLastName?: string;
    patronymic?: string;
}

export function formatFullName({ firstName, lastName, oldLastName, patronymic }: FullNameParams): string {
    const oldLastNamePart = oldLastName ? ` (${oldLastName}) ` : ' ';
    return `${lastName || ''}${oldLastNamePart}${firstName || ''}${patronymic ? ` ${patronymic}` : ''}`;
}
